import { Component, OnInit } from '@angular/core';

import { PlantMapService } from '../services/plant-map.service';

import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { LayoutService } from '../../shared/services/layout.service';
import { StorageService } from '../../shared/services/storage.service';
import { PopupService } from '../../shared/services/pop-up.service';
import { CONFIGURATION } from '../../shared/configuration/configuration';
import { STATIC_VALUE } from '../../shared/configuration/static.value';

declare var L: any;

@Component({
    selector: 'plantmap-area-of-interest',
    templateUrl: 'area-of-interest.component.html'
})

export class PlantmapAreaOfInterestComponent implements OnInit{

    map: any;
    showInstruction: boolean = true;
    vSearchVal: string = "";
    vSelectedSearch;
    vSearchResultVisible: boolean = false;

    vDrawControl;
    drawnItems;
    isDrawing: boolean = false;
    vPoints;

    vLoadingSearch: boolean = false;

    vPrevDraw;

    constructor(
        private _layoutService: LayoutService,
        private _storageService: StorageService,
        private _pageNavigationService: PageNavigationService,
        private _plantMapService: PlantMapService,
        private _popupService: PopupService
    ) {
        
    }

    ngOnInit() {
        this.vSearchVal = this._plantMapService.vEarthworkDetailsData.location;//kowsalya
    	this._layoutService.setCurrentPage('plantmap-area-of-interest');
        this.map = L.map('map', { zoomControl: true }).setView([1.3577462, 103.8110818], 12);
        L.control.scale().setPosition("bottomright").addTo(this.map);
        this.map.zoomControl.setPosition("bottomright");
        //L.tileLayer('http://maps-{s}.onemap.sg/v2/Original/{z}/{x}/{y}.png').addTo(this.map);
        let modeEnv = CONFIGURATION.modeEnv;
        // had to be changed from below to above URL, due to upgradation of One Map’s APIs
        // old URL: https://www.onemap.gov.sg/maps/tiles/Default/{z}/{x}/{y}.png
        if (modeEnv == 'PROD') {
            L.tileLayer('https://www.onemap.gov.sg/maps/tiles/Default/{z}/{x}/{y}.png').addTo(this.map);
        } else {
            L.tileLayer('https://www.onemap.gov.sg/maps/tiles/Default/{z}/{x}/{y}.png').addTo(this.map);

        }
        this.drawnItems = new L.FeatureGroup();
        this.map.addLayer(this.drawnItems);

        this.map.on(L.Draw.Event.CREATED, (event) => {
            this.clear();
            var layer = event.layer;
            this.vPoints = layer._latlngs[0].length > 3 ? layer._latlngs[0] : undefined;
            this.drawnItems.addLayer(layer);
            this.isDrawing = false;
        });

        
        this.vDrawControl = new L.Draw.Rectangle(this.map, {
            shapeOptions: {
                color: "red"
            }
        });

        this._plantMapService.resetPlantMapData();
        this._plantMapService.resetAreaOfInterest();
        this._plantMapService.resetError();
        this.getPrevDraw();
    }

    getPrevDraw(){
        if(this._plantMapService.getPrevDraw().length === 2){
            this.map.whenReady(() => {
                var bounds = this._plantMapService.getPrevDraw();
                this.vPrevDraw = L.rectangle([bounds], {color: "#FF0000", weight: 4, fill:"#FF0000", fillOpacity: 0.2, opacity: 0.5}).addTo(this.map);
                this.map.fitBounds(bounds);
                this.vPoints = [
                    {lat: this._plantMapService.getAreaOfInterestData().coordinate11, lng: this._plantMapService.getAreaOfInterestData().coordinate12},
                    {lat: this._plantMapService.getAreaOfInterestData().coordinate21, lng: this._plantMapService.getAreaOfInterestData().coordinate22},
                    {lat: this._plantMapService.getAreaOfInterestData().coordinate31, lng: this._plantMapService.getAreaOfInterestData().coordinate32},
                    {lat: this._plantMapService.getAreaOfInterestData().coordinate41, lng: this._plantMapService.getAreaOfInterestData().coordinate42},
                ]
            });
        }
    }

    removePrevDraw(){
        if(this.vPrevDraw !== undefined){
            this.vPrevDraw.remove();
        }
    }

    setShowInstruction() {
        this.showInstruction = !this.showInstruction;
    }
    getShowInstruction() {
        return this.showInstruction;
    }

    getAreaOfInterestData(){
        return this._plantMapService.getAreaOfInterestData();
    }

    submitAreaOfInterest(){
        this._plantMapService.saveAreaOfInterest();
    }

    goBack(){
        let vLink = ['plant-map/earthwork-details'];
        this._pageNavigationService.navigate(vLink);
    }

    isDisableSave(){
        return this._plantMapService.isDisableAreaOfInterest();
    }

    getSearchResults(){
        return this._plantMapService.getSearchResults();
    }

    search(){
        this._plantMapService.vSearchResults = [];
        if(this.vSearchVal === '' || this.vSearchVal === undefined){
            return;
        }
        this.vLoadingSearch = true;
        this._plantMapService.search(this.vSearchVal).then(
            (resolve) => {
                this.vLoadingSearch = false;
            },
            (reject) => {
                this.vLoadingSearch = false;
            }
        );
        this.vSearchResultVisible = true;
    }

    goToSelected(pLocationName, pLatitude, pLongitude){
        if(this.vSelectedSearch !== undefined){
            this.map.removeLayer(this.vSelectedSearch);
        }
        this.vSelectedSearch = L.marker([pLatitude, pLongitude]);
        this.map.addLayer(this.vSelectedSearch);
        this.vSelectedSearch.bindPopup(pLocationName).openPopup();
        this.map.panTo(L.latLng(pLatitude, pLongitude));
        this.map.setView([pLatitude, pLongitude], 17);
    }

    fireEvent(){
        this.vSearchResultVisible = false;
    }

    isLoading(){
        return this._plantMapService.isLoading();
    }

    /*disableDrag(){
        this.map.dragging.disable();
    }

    enableDrag(){
        this.map.dragging.enable();
    }*/

    draw(){
        if(!this.isDrawing){
            this.vDrawControl.enable();
            this.isDrawing = true;
        }else {
            this.vDrawControl.disable();
            this.isDrawing = false;
        }
    }

    clear(){
        let data = {
            a2_amount: 0, 
            restricted_area: -1,
            amount_payable: 0,
            coordinate11 : 0,
            coordinate12 : 0,
            coordinate21 : 0,
            coordinate22 : 0,
            coordinate31 : 0,
            coordinate32 : 0,
            coordinate41 : 0,
            coordinate42 : 0
        };

        this._plantMapService.setAreaOfInterestData(data);
        this.removePrevDraw();
        this.drawnItems.clearLayers();
        this.vPoints = undefined;
        this._storageService.removeSessionItem('plantMapAreaInterest');
    }

    //Kowsalya
        distance(lat1, lon1, lat2, lon2, unit) {

            console.log("Line 210",lat1, lon1, lat2, lon2, unit); 
            if ((lat1 == lat2) && (lon1 == lon2)) {
                return 0;
            }
            else {
                var radlat1 = Math.PI * lat1/180;
                var radlat2 = Math.PI * lat2/180;
                var theta = lon1-lon2;
                console.log("Line 218",theta);
                var radtheta = Math.PI * theta/180;
                var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                console.log("Line 221", dist);
                if (dist > 1) {
                    dist = 1;
                console.log("Line 224", dist);       
                }
                dist = Math.acos(dist);
                dist = dist * 180/Math.PI;
                dist = dist * 60 * 1.1515;
                if (unit=="K") { dist = dist * 1.609344 }
                if (unit=="N") { dist = dist * 0.8684 }
                //alert(dist);
                console.log("Line 232",dist);  
        
                return dist;
            }
        }
        //Kowsalya

        verify(){
        if(this.vPoints !== undefined){
            //Kowsalya
            var distanceVal = STATIC_VALUE.DISTANCE.distanceKm;
            console.log("Line 245", distanceVal);
            var dist = this.distance(this.vPoints[0].lat,this.vPoints[0].lng,this.vPoints[1].lat,this.vPoints[1].lng,"K");
            var dist1 = this.distance(this.vPoints[0].lat,this.vPoints[0].lng,this.vPoints[3].lat,this.vPoints[3].lng,"K");
            console.log(this.vPoints);
            console.log("Line 250",dist,dist1);

            if ((!(this.vPoints[0].lat>STATIC_VALUE.MAP_BOUNDARY.latMin && this.vPoints[0].lng>STATIC_VALUE.MAP_BOUNDARY.lngMin && this.vPoints[1].lat>STATIC_VALUE.MAP_BOUNDARY.latMin && this.vPoints[1].lng>STATIC_VALUE.MAP_BOUNDARY.lngMin)||
                !(this.vPoints[0].lat<STATIC_VALUE.MAP_BOUNDARY.latMax && this.vPoints[0].lng<STATIC_VALUE.MAP_BOUNDARY.lngMax && this.vPoints[1].lat<STATIC_VALUE.MAP_BOUNDARY.latMax && this.vPoints[1].lng<STATIC_VALUE.MAP_BOUNDARY.lngMax))&&
                (!(this.vPoints[0].lat>STATIC_VALUE.MAP_BOUNDARY1.latMin && this.vPoints[0].lng>STATIC_VALUE.MAP_BOUNDARY1.lngMin && this.vPoints[1].lat>STATIC_VALUE.MAP_BOUNDARY1.latMin && this.vPoints[1].lng>STATIC_VALUE.MAP_BOUNDARY1.lngMin)||
                !(this.vPoints[0].lat<STATIC_VALUE.MAP_BOUNDARY1.latMax && this.vPoints[0].lng<STATIC_VALUE.MAP_BOUNDARY1.lngMax && this.vPoints[1].lat<STATIC_VALUE.MAP_BOUNDARY1.latMax && this.vPoints[1].lng<STATIC_VALUE.MAP_BOUNDARY1.lngMax)))
                {
                    this._popupService.openPopup( 'confirmation', {
                        title: 'Notice',
                        message: STATIC_VALUE.OUT_OF_SINGAPORE,
                        buttons: {
                            OK: {
                                text: 'OK',
                                function: () => {
                                    this._popupService.closeConfirmationPopup();
                                }
                            }
                        }}
                    );
                }
                else
                {
                    if (dist>distanceVal || dist1>distanceVal)
                    {
                       // alert(STATIC_VALUE.DISTANCE_MSG);
                        this._popupService.openPopup( 'confirmation', {
                            title: 'Notice',
                            message: STATIC_VALUE.DISTANCE_MSG,
                            buttons: {
                                OK: {
                                    text: 'OK',
                                    function: () => {
                                        this._popupService.closeConfirmationPopup();
                                    }
                                }
                            }}
                        );
                    }  //Kowsalya
        
                    else{
        
                        this._plantMapService.loadA2AmountandAmountPay(this.vPoints).then(
                            (resolve) => {
                                console.warn(resolve,'resolve')
                                let data = resolve['data'];
                                if(data.restricted_area == 1) {
                                    this._popupService.openPopup('restricted-confirmation', {
                                        title: 'Notice',
                                        buttons: {
                                            OK: {
                                                text: 'Proceed (Approval required)',
                                                function: () => {
                                                    this._plantMapService.vAreaOfInterestData.restricted_area = 1;
                                                    this._storageService.setSessionItem('plantMapAreaInterest', JSON.stringify(this._plantMapService.vAreaOfInterestData));
                                                    this._plantMapService.vAreaOfInterestData.flow = 'restricted';
                                                    this._storageService.setSessionItem('flowtype', 'restricted');
                                                    this._popupService.closePopup();
                                                }
                                            },
                                            NO: {
                                                text: 'Proceed without restricted details',
                                                function: () => {
                                                    this._plantMapService.vAreaOfInterestData.restricted_area = 0;
                                                    this._storageService.setSessionItem('plantMapAreaInterest', JSON.stringify(this._plantMapService.vAreaOfInterestData));
                                                    this._plantMapService.vAreaOfInterestData.flow = 'normal';
                                                    this._storageService.setSessionItem('flowtype', 'normal');
                                                    this._popupService.closePopup();
                                                }
                                            },
                                            CANCEL: {
                                                text: 'Cancel',
                                                function: () => {
                                                    this.clear();
                                                    this._popupService.closePopup();
                                                }
                                            }
                                        }
                                    });
                                } else {
                                    this._plantMapService.vAreaOfInterestData.restricted_area = 0;
                                    this._storageService.setSessionItem('plantMapAreaInterest', JSON.stringify(this._plantMapService.vAreaOfInterestData));
                                    this._plantMapService.vAreaOfInterestData.flow = 'normal';
                                    this._storageService.setSessionItem('flowtype', 'normal');

                                }
                            },
                            (reject) => {}
                        );
                    }
                }

        }
    }

    /*verify(){
        this._plantMapService.loadA2AmountandAmountPay(this.vPoints).then(
            (resolve) => {
                let data = resolve['data'];
                if(data.restricted_area == 1) {
                    this._popupService.openPopup('restricted-confirmation', {
                        title: 'Notice',
                        buttons: {
                            OK: {
                                text: 'Proceed (Approval required)',
                                function: () => {
                                    this._plantMapService.vAreaOfInterestData.restricted_area = 1;
                                    this._storageService.setSessionItem('plantMapAreaInterest', JSON.stringify(this._plantMapService.vAreaOfInterestData));
                                    this._popupService.closePopup();
                                }
                            },
                            NO: {
                                text: 'Proceed without restricted details',
                                function: () => {
                                    this._plantMapService.vAreaOfInterestData.restricted_area = 0;
                                    this._storageService.setSessionItem('plantMapAreaInterest', JSON.stringify(this._plantMapService.vAreaOfInterestData));
                                    this._popupService.closePopup();
                                }
                            },
                            CANCEL: {
                                text: 'Cancel',
                                function: () => {
                                    this.clear();
                                    this._popupService.closePopup();
                                }
                            }
                        }
                    });
                } else {
                    this._plantMapService.vAreaOfInterestData.restricted_area = 0;
                    this._storageService.setSessionItem('plantMapAreaInterest', JSON.stringify(this._plantMapService.vAreaOfInterestData));
                }
            },
            (reject) => {}
        );
    }*/
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/plantmap/components/area-of-interest.component.ts